import { createContext } from 'react';
import type { Image } from 'canvas';

import type { RenderPlan } from '../Renderer/Renderbot/RenderPlan';
import type RasterSpool from '../Renderer/Renderbot/Output/RasterSpool';
import type BoundedImages from '../Renderer/Renderbot/Images/BoundedImages';

export default class ImageLibrary {
    public bounded?: BoundedImages;
    public renderJob?: { plan: RenderPlan, spool: RasterSpool };
    public images:Map<string, Image> = new Map<string, Image>();

    public retrieveImage(filename:string) {
        //Grab from cache
        if(this.images.has(filename)) {
            return this.images.get(filename);
        }

        //Trigger error
        throw new Error('Image '+filename+' not found');
    }
}

export const ImageLibraryContext = createContext(new ImageLibrary)